var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSc = function SvgSc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M0 0h682.67v512H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "scale(.9375)",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M0 0h992.13v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 512l992.12-170.67V512H0z",
    fill: "#090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 512l992.12-341.33v170.67L0 512z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 512V0h330.71L0 512z",
    fill: "#009"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 512L330.71 0h330.71L0 512z",
    fill: "#ff0"
  }))));
};
export default __webpack_public_path__ + "assets/b174a49f50449d777e3ea80776af22da.svg";
export { SvgSc as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/sc.svg